"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = {
  props: {
    status: String,
    hasPoint: {
      type: Boolean,
      default: false
    }
  }
};
exports.default = _default;